import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Flex,
} from '@chakra-ui/react';
import {
  useEffect,
  useMemo,
} from 'react';
import useChargebeeCheckoutHostedPage from '../../hooks/chargebee/useChargebeeCheckoutHostedPage';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import { INTAKE_PAYMENT_STARTED } from '../../services/analytics/events';
import {
  useTrack,
} from '../../services/analytics/hooks';

const ChargebeeForm = ({
  business,
  onComplete,
}: {
  business: BusinessModel,
  onComplete: () => void,
}) => {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, []);
  useTrack(INTAKE_PAYMENT_STARTED);

  const [openCheckoutWidget, chargebeeInstance, checkoutError] = useChargebeeCheckoutHostedPage(business);

  const openCheckout = useMemo(
    () => () => {
      if (!openCheckoutWidget) return null;
      return openCheckoutWidget({
        step: (value: string) => {
          if (value === 'thankyou_screen') onComplete();
        },
      });
    },
    [openCheckoutWidget],
  );

  useEffect(
    () => {
      if (!chargebeeInstance) return;
      openCheckout();
    },
    [chargebeeInstance, openCheckoutWidget],
  );

  return (
    <>
      {checkoutError && (
        <Alert status="error" flexDirection="row" mb="1em">
          <AlertIcon />
          <Flex flexDirection="column" gap="1em" w="100%">
            <AlertTitle>Something went wrong</AlertTitle>
            <AlertDescription>
              Try again or contact <a href="mailto:support@getintheloop.ca">support@getintheloop.ca</a>.
            </AlertDescription>
          </Flex>
        </Alert>
      )}
      <Button onClick={openCheckout} size="lg" colorScheme="blue">Open Checkout</Button>
    </>
  );
};

export default ChargebeeForm;
